import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MyFeedsServiceService {

  constructor(
    private http: HttpClient
  ) { }

  getPatientDetails() {
     //return this.http.get("https://connect.medlineplus.gov/application?mainSearchCriteria.v.cs=2.16.840.1.113883.6.88&mainSearchCriteria.v.c=%20637188%20&mainSearchCriteria.v.dn=Chantix%200.5%20MG%20Oral%20Tablet&informationRecipient.languageCode.c=en");

    //  https://connect.medlineplus.gov/service?mainSearchCriteria.v.c=493.22&mainSearchCriteria.v.cs=2.16.840.1.113883.6.103&mainSearchCriteria.v.dn=&informationRecipient.languageCode.c=en&knowledgeResponseType=application%2Fjson

    // return this.http.get("https://wsearch.nlm.nih.gov/ws/query?db=healthTopics&term=asthma");

    return this.http.get("https://connect.medlineplus.gov/service?mainSearchCriteria.v.c=493.22&mainSearchCriteria.v.cs=2.16.840.1.113883.6.103&mainSearchCriteria.v.dn=&informationRecipient.languageCode.c=en&knowledgeResponseType=application%2Fjson");
  }

}
